import { ArcBuilderFieldEnum } from './arc-builder-field.enum';

export class ArcBuilderField {
  public FieldType: ArcBuilderFieldEnum;
  public FieldName: string;
  public FieldId: number;

  public constructor() {
    this.FieldType = null;
    this.FieldName = '';
    this.FieldId = 0;
  }
}
